/**
 * LogisticsTab — freight + tracking + customs in one tab.
 */
import React from 'react';
import FreightQuotePanel from '../components/FreightQuotePanel';
import TrackingPanel from '../components/TrackingPanel';
import CustomsChecklist from '../components/CustomsChecklist';
import PdfPreview from '../components/PdfPreview';
import { useManifest } from '../ManifestContext';
import { Stamp, Truck } from 'lucide-react';

const LogisticsTab = () => {
  const { activeOrder } = useManifest();
  const customs = activeOrder.customs;

  return (
    <div className="manifest-tab-pane">
      <FreightQuotePanel order={activeOrder} />
      <TrackingPanel order={activeOrder} />
      <CustomsChecklist order={activeOrder} />

      {customs?.docs && (
        <>
          <div className="manifest-section-head" style={{ marginTop: '20px' }}>
            <h3><Stamp size={16} /> Auto-generated customs paperwork</h3>
            <span>Generated by Co-Pilot from the contract + freight + factory data</span>
          </div>
          <div className="logistics-customs-docs">
            <PdfPreview
              title="Commercial Invoice"
              fileName={customs.docs.commercialInvoice?.name || 'commercial-invoice.pdf'}
              badge="Generated"
            >
              <div className="pdf-meta-block">
                <div><strong>Exporter:</strong> {activeOrder.factories?.find((f) => f.id === activeOrder.pickedQuoteFactoryId)?.name}</div>
                <div><strong>Importer:</strong> [AI]Quire Procurement Inc.</div>
                <div><strong>Country of origin:</strong> China</div>
                <div><strong>Country of destination:</strong> Canada</div>
                <div><strong>Total value (USD):</strong> ${(activeOrder.contractValueCad / 1.35).toFixed(0)}</div>
              </div>
              <div className="pdf-divider" />
              <div className="pdf-spec-section">
                <div className="pdf-spec-heading">Goods description</div>
                <div className="pdf-spec-body">{activeOrder.productSummary}</div>
              </div>
              <div className="pdf-footer">CBSA-compliant · Auto-generated by Co-Pilot</div>
            </PdfPreview>
            <PdfPreview
              title="Certificate of Origin"
              fileName={customs.docs.certOfOrigin?.name || 'cert-of-origin.pdf'}
              badge="Issued"
            >
              <div className="pdf-meta-block">
                <div><strong>Manufacturer:</strong> {activeOrder.factories?.find((f) => f.id === activeOrder.pickedQuoteFactoryId)?.name}</div>
                <div><strong>Country of origin:</strong> China</div>
                <div><strong>Goods:</strong> {activeOrder.productSummary}</div>
                <div><strong>Tariff classification:</strong> Pending broker assignment</div>
              </div>
              <div className="pdf-divider" />
              <p>This is to certify that the goods described above are wholly produced or manufactured in the country of origin shown.</p>
              <div className="pdf-footer">Issued by manufacturer · Validated by broker</div>
            </PdfPreview>
          </div>
        </>
      )}

      {!customs && (
        <div className="manifest-empty manifest-empty-inline" style={{ marginTop: '20px' }}>
          <Truck size={20} />
          <p>Customs paperwork is auto-prepared by Co-Pilot once goods leave the factory. Not yet at this phase.</p>
        </div>
      )}
    </div>
  );
};

export default LogisticsTab;
